import { Button, Grid } from '@material-ui/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import React, { useRef } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { ResponsiveContainer } from 'recharts';
import ReportStyle from '../../../reports/ClaimReport/Report.module.css';
import styles from '../../../reports/ClaimReport/Table.module.css';
import CmsfLogo from '../../../reports/ClaimReport/logo.png';




const UiOfCompanySummaryReport = ({ data ,inwardDividendType,tableData,dataType,grandTotal}) => {

  const params = useParams();
  const pdfRef = useRef();
  const pdfRef2 = useRef();

  const contentRef = useRef();

  const columns = [
    {
      accessorKey: 'id',
      header: 'SL',
      size: 50,
      Cell: ({ row }) => row.index + 1,
     },
    // { accessorKey: "id", header: "ID", size: 50 },
    { accessorKey: "issuername", header: "Issuer Name", size: 50 },
    { accessorKey: "nst", header: "Received", size: 50 },
    { accessorKey: "sett", header: "Settled", size: 50 ,},
    { accessorKey: "outs", header: "Outstanding", size: 50 },
  ];

  const generatePdf = () => {
    const pdf = new jsPDF('p', 'mm', 'a4'); // Create a new PDF document
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    html2canvas(pdfRef.current, {
      scale: 2,
      useCORS: true,
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const aspectRatio = imgHeight / imgWidth;
      const scaleFactor = pdfWidth / imgWidth;
      let remainingHeight = imgHeight;
      let position = 0;

      while (remainingHeight > 0) {
        const currentHeight = Math.min(remainingHeight, pdfHeight / scaleFactor);

        pdf.addImage(
          imgData,
          'PNG',
          0,
          position,
          pdfWidth,
          pdfWidth * aspectRatio * (currentHeight / imgHeight),
          undefined,
          'FAST'
        );

        remainingHeight -= currentHeight;
        position = -((imgHeight - remainingHeight) / scaleFactor);

        if (remainingHeight > 0) {
          pdf.addPage();
          position = 0;
        }
      }

      pdf.save('Company_Summary_Report.pdf');
    });
  };

  const generatePdf2 = async () => {
    const content = pdfRef.current;

    const pdf = new jsPDF('p', 'mm', 'a4');
    const canvas = await html2canvas(content);
    const imgData = canvas.toDataURL('image/png');

    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;

    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save('Company_Summary_Report.pdf');
  };
  

  const handleDownloadPDF = () => {
    const doc = new jsPDF("portrait"); 
  

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
  
    const companyInfo = {
      name: "Capital Market Stabiliztion Fund",
      address:
        "Dhaka Chamber Building(3rd Floor), 65-66 Motijheel C/A, Dhaka-1000\nTel: +880241052430, Email: claim@cmsfbd.org",
    };
  
    const reportInfo = {
      title: "Company-wise Dividend Summary Report",
      instrument: `CMSF received the following amount of ${inwardDividendType} Dividends by the Issuer Company/Companies:`,
      investorCode: `Dividend Type: ${inwardDividendType}`,
      // dateRange: `From`,
    };
  
    // Add company header
    doc.setFontSize(12);
    doc.text(companyInfo.name, 14, 13);
    doc.setFontSize(8);
    doc.text(companyInfo.address, 14, 19);
    doc.setFont("helvetica", "bold");
  
    // Add report title and other info
    doc.setFontSize(8);
    doc.text(reportInfo.title, pageWidth - 14, 15, { align: "right" });
    doc.text(reportInfo.investorCode, 14, 32);
     doc.text(reportInfo.instrument, 14, 36);
    // doc.text(reportInfo.dateRange, 14, 40);
  
    // Table columns
    const tableColumns = columns.map((column) => column.header);
  
    // Prepare table data for PDF
    const tableDataForPDF = tableData.map((row, index) => {
      return columns.map((column) => {
        if (column.accessorKey === "id") {
          return index + 1;
        }
        if (column.accessorKey === "transaction_date") {
          const rawDate = row[column.accessorKey];
          const date = new Date(rawDate);
          return date
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
            .replace(/ /g, "-"); // Format: '02-Jan-2022'
        }
        if (column.accessorKey === "nst" || column.accessorKey === "sett" || column.accessorKey === "outs"  ) {
          const rawValue = row[column.accessorKey];
          const value = Number(rawValue); // Ensure it's a number
          return isNaN(value) ? "0.00" : value.toFixed(2); // Format to 2 decimal places, handle invalid values
        }
        return row[column.accessorKey];
      });
    });

   // Add "Total" row at the bottom
  const totalRow = columns.map((column) => {
    if (column.accessorKey === "issuername") return "Total"; 
    if (column.accessorKey === "nst") return grandTotal.nst.toFixed(2); 
    if (column.accessorKey === "sett") return grandTotal.sett.toFixed(2); 
    if (column.accessorKey === "outs") return grandTotal.outs.toFixed(2); 
    return ""; 
  });

    tableDataForPDF.push(totalRow); // Append the total row at the bottom
    // Get current date & time
    const currentDateTime = new Date()
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(",", "");
  
    doc.autoTable({
      head: [tableColumns],
      body: tableDataForPDF,
      startY: 43,
      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 1.2,
        lineWidth: 0,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: "#000000",
        halign: "center",
        lineWidth: 0.5,
      },
      bodyStyles: {
        textColor: "#000000",
        halign: "left",
      },
      columnStyles: {
        0: { halign: "left" },
      },
      tableWidth: "auto",

        // Bold "Total" and total quantity
      didParseCell: function (data) {
      const rowIndex = data.row.index;
      const lastRowIndex = tableDataForPDF.length - 1;

      if (rowIndex === lastRowIndex) {
        data.cell.styles.fontStyle = "bold"; // Make "Total" row bold
        data.cell.styles.fontSize = 9; // Increase text size
      }
    },
      didDrawCell: (data) => {
        if (data.section === "body") {
          const doc = data.doc;
          const { cell } = data;
  
          doc.setLineDash([1, 1], 0);
          doc.setDrawColor(130, 130, 130);
  
          doc.line(cell.x, cell.y, cell.x + cell.width, cell.y); // Top line
          doc.line(cell.x, cell.y + cell.height, cell.x + cell.width, cell.y + cell.height); // Bottom line
        }
      },
      didDrawPage: (data) => {
        // Add Date & Time on the bottom-left corner
        doc.setFont("helvetica", "italic");
        doc.setFontSize(8);
        doc.setTextColor(149, 149, 149);
        doc.text(`Print Date & Time: ${currentDateTime}`, 14, pageHeight - 10);
  
        // Add Page Number on the bottom-right corner
        const pageNumber = `Page ${data.pageNumber}`;
        doc.text(pageNumber, pageWidth - 14, pageHeight - 10, { align: "right" });
      },
    });
  
    // Save the PDF
    doc.save("Company_Summary_Report.pdf");
  };


  return (
    <>
  

<ResponsiveContainer style={{ width: '85%', maxWidth: '100%', padding: '10px' }}>
    
<Grid ref={pdfRef2} className={ReportStyle.form}> 

</Grid>

<Grid ref={pdfRef} className={ReportStyle.form}>

<Grid className={ReportStyle.headerLogo}>
          <div className={ReportStyle.CmsfLogo}>
        {/* <img className={ReportStyle.Golden50} src={Golden50} alt='CMSF Logo' /> */}
          </div>
          <div className={ReportStyle.CmsfLogo}>
        <img className={ReportStyle.CmsfLogo} src={CmsfLogo} alt='CMSF Logo' />
          </div>
          <div className={ReportStyle.Mujib100}>
        {/* <img className={ReportStyle.Mujib100} src={Mujib100} alt='CMSF Logo' /> */}
          </div>

      </Grid>

  <Grid className={ReportStyle.address} style={{ textAlign: 'center', fontSize: '1rem', margin: '10px 0' }}>
    <span>Dhaka Chamber Building(3rd Floor), 65-66 Motijheel C/A, Dhaka-1000</span><br />
    <span>Tel: +880241052430, Email: claim@cmsfbd.org</span>
  </Grid>

  <h1 style={{ textAlign: 'center', fontSize: '2rem' }}><strong>Company-wise Dividend Summary Report</strong></h1>

  <h5 className={ReportStyle.GategoryName} style={{ textAlign: 'center' }}> Dividends sent to CMSF</h5>

  <h5>CMSF received the following amount of {inwardDividendType} Dividends by the mentioned Company/Companies:</h5>

  <Grid className={ReportStyle.GategoryName2} style={{ overflowX: 'auto' }}>
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr>
          <th className={styles.td} colSpan={3}>Sl</th>
          <th className={styles.td} colSpan={3}>Issuer Name</th>
          <th className={styles.td} colSpan={3}>{inwardDividendType==='Cash' ? 'Received Cash' : 'Received Stock' }</th>
          <th className={styles.td} colSpan={3}>{inwardDividendType==='Cash' ? 'Settled Cash' : 'Settled Stock' }</th>
          <th className={styles.td} colSpan={3}>{inwardDividendType==='Cash' ? 'Outstanding Cash' : 'Outstanding Stock' }</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr key={index} style={{ backgroundColor: item.sett !== null ? '#50C878' : '' }}>
            <td className={styles.td} colSpan={3}>{index + 1}</td>
            <td className={styles.td} colSpan={3}>{item.issuername}</td>
            <td className={styles.td} colSpan={3}>{item.nst !== null ? item.nst.toFixed(2) : 0}</td>
            <td className={styles.td} colSpan={3}>{item.sett !== null ? item.sett.toFixed(2) : 0}</td>
            <td className={styles.td} colSpan={3}>{item.outs !== null ? item.outs.toFixed(2) : 0}</td>
          </tr>
        ))}
        <tr>
          <td className={styles.td} colSpan={6} style={{ fontSize: '1.3rem', textAlign: 'center', fontWeight: 'bold' }}>Total</td>
          <td className={styles.td} colSpan={3} style={{ fontSize: '1rem', fontWeight: 'bold' }}>{grandTotal.nst.toFixed(2)}</td>
          <td className={styles.td} colSpan={3} style={{ fontSize: '1rem', fontWeight: 'bold' }}>{grandTotal.sett.toFixed(2)}</td>
          <td className={styles.td} colSpan={3} style={{ fontSize: '1rem', fontWeight: 'bold' }}>{grandTotal.outs.toFixed(2)}</td>
        </tr>
      </tbody>
    </table>
  </Grid>

  <Grid className={ReportStyle.msgDiv}>
    <span className={ReportStyle.msg}><i>This is a system-generated report.</i></span>
  </Grid>
</Grid>

<Button 
  style={{ margin: '10px', marginTop: '20px', backgroundColor: '#45CFDD' }}  
  variant="contained" 
  color="default" 
  onClick={handleDownloadPDF}
>
  Download Summary Report
</Button>

</ResponsiveContainer>
</>
  );
};

export default UiOfCompanySummaryReport;
